var initialized = false;
export var initCoralogix = function (variant) {
    if (initialized)
        return;
    initialized = true;
    var apmEnabled = process.env.REACT_APP_APM_ENABLED === 'true';
    if (!apmEnabled)
        return;
    var publicKey = process.env.REACT_APP_APM_PUBLIC_KEY || '';
    var application = process.env.REACT_APP_APM_APPLICATION || '';
    var domain = process.env.REACT_APP_APM_DOMAIN || '';
    var version = process.env.REACT_APP_APM_VERSION || '';
    var subsystem = process.env.REACT_APP_APM_SUBSYSTEM || '';
    var environment = process.env.REACT_APP_APM_ENVIRONMENT || '';
    var sampleRateRaw = process.env.REACT_APP_APM_SESSION_SAMPLE_RATE || '';
    if (!publicKey || !application || !domain) {
        console.warn('Coralogix: required REACT_APP_APM_* env vars missing — skipping init');
        return;
    }
    var sessionSampleRate = parseInt(sampleRateRaw, 10);
    if (isNaN(sessionSampleRate))
        sessionSampleRate = 100;
    // Pre-load queue stub: calls made before the SDK script finishes
    // loading are pushed onto `.q` and replayed by the SDK on init.
    window.CoralogixRum =
        window.CoralogixRum ||
            function () {
                (window.CoralogixRum.q = window.CoralogixRum.q || []).push(arguments);
            };
    var js = document.createElement('script');
    js.src =
        'https://cdn.rum-ingress-coralogix.com/coralogix/browser/2.3.0/coralogix-browser-sdk.js';
    js.async = true;
    js.onload = function () {
        try {
            window.CoralogixRum.init({
                public_key: publicKey,
                application: application,
                version: version,
                coralogixDomain: domain,
                sessionSampleRate: sessionSampleRate,
                environment: (environment || 'unknown').toLowerCase(),
                labels: { subsystem: subsystem, variant: variant },
                // Disable auto-instrumentation — we send only the explicit
                // events emitted via the IAPM wrapper to keep ingest volume
                // (and cost) predictable.
                instrumentations: {
                    errors: false,
                    fetch: false,
                    xhr: false,
                    web_vitals: false,
                    long_tasks: false,
                    interactions: false,
                    resources: false,
                },
            });
        }
        catch (e) {
            console.error('Coralogix RUM init error:', e);
        }
    };
    document.head.appendChild(js);
};
